

import { Component, Vue, Watch, Prop } from 'vue-property-decorator'


import {Form, FormItem} from 'kpc/components/form'
import Button, { ButtonGroup } from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';
import {
    forEach,
    filter,
    last
} from "lodash";


import * as regionService from '../../../services/kec/region'

const eventName = 'regionChange'


interface IArea {
    rowIdx: number
    classNames: string[]
    code: string
    regions: regionService.IRegion[]
}

@Component({
    components: {
        Form, FormItem,
        Button, ButtonGroup,
        Tooltip
    }
})
export default class RegionConfig extends Vue {


    @Prop({
        required: true
    })
    regionList:regionService.IRegion[][] = []

    @Prop({
        required: true
    })
    region:string = ''


    regionCheck:string = ''


    regionService = regionService

    filter = filter


    areas:IArea[] = []
    rowIdxSet: Set<number> = new Set()

    @Watch('regionList', {
        deep: true
    })
    regionListWatch() {
        this.formatRegionList();
    }
    @Watch('region')
    regionWatcher(val:string) {
        if (val !== this.regionCheck) {
            this.regionCheck = val;
        }
    }

    @Watch('regionCheck')
    regionCheckWatcher() {
        if (this.regionCheck !== this.region) {
            this.$emit(eventName, this.regionCheck)
        }
    }



    formatRegionList() {
        let list = this.regionList;

        // 清空选项
        let areas:IArea[] = []

        let currentArea:IArea
        let preArea:IArea

        let rowIdxSet = new Set<number>()

        forEach(list, (regions, rowIdx) => {
            forEach(regions, region => {

                // 如果当前area已经初始化，且是当前region所属的area，且没有换行
                if (currentArea && currentArea.rowIdx === rowIdx && currentArea.code === region.areaCode) {
                    currentArea.regions.push(region);
                    return;
                }

                rowIdxSet.add(rowIdx)

                // 初始化新area，旧area作为pre项，用于判断样式
                preArea = currentArea;
                currentArea = {
                    rowIdx,
                    classNames: [], // 初始化的时候不处理class，整体格式化完再处理
                    code: region.areaCode,
                    regions: [region]
                }
                areas.push(currentArea);

                // 判断样式
                if (preArea) {
                    if (preArea.code !== currentArea.code) {
                        currentArea.classNames.push('line_left');
                        if (preArea.rowIdx !== currentArea.rowIdx) {
                            preArea.classNames.push('line_right')
                        }
                    }
                } else {
                    currentArea.classNames.push('line_left');
                }
            })
        });

        // 最后一项需要收尾样式
        let lastArea = last(areas);
        lastArea?.classNames.push('line_right')

        this.areas = areas;
        this.rowIdxSet = rowIdxSet;

    }


    // fetchAreaList(val) {
    //     console.log(val, 'fetchArea')
    //     if (val.length) {
    //         let areaList = [];
    //         let tempData = '';
    //         _.forEach(val, (item) => {
    //             if (tempData != item.areaCode) {
    //                 areaList.push(_.filter(val, (subitem) => {
    //                     return subitem.areaCode == item.areaCode;
    //                 }) || []);
    //             }
    //             tempData = item.areaCode;
    //         });
    //         console.log(areaList)
    //         return areaList;
    //     }
    // }
    // filterAreaGroup(val, idx) {
    //     // if (val.length) {
    //     //     let i = idx - 1 ? idx : 0;
    //     //     if (idx > i) {
    //     //         let areaCodeArr = _.map(this.newBossRegionList[i], 'areaCode');
    //     //         return _.includes(areaCodeArr, val);
    //     //     }
    //     // }
    //     if (val.length) {
    //         let lineLeft = "line_left";
    //         let lineRight = "";
    //         let i = idx - 1 ? idx : 0;
    //         let j = idx + 1;
    //         if (idx > i) {
    //             let iArr = _.map(this.newBossRegionList[i], 'areaCode');
    //             lineLeft = _.includes(iArr, val) ? "" : "line_left";
    //         }
    //         if (val == _.last(this.newBossRegionList[idx]).areaCode) {
    //             let jArr = _.map(this.newBossRegionList[j], 'areaCode');
    //             lineRight = _.includes(jArr, val) ? "" : "line_right";
    //         }
    //
    //         return lineLeft + " " + lineRight;
    //     }
    // },

}

